import {
  isPossibleNumber,
  isValidNumber,
  parsePhoneNumber,
} from "libphonenumber-js";
import React, { useContext, useState } from "react";
import OtpInput from "react-otp-input";
import ResendOtp from "../../apps/Website/pages/Checkin/components/ReseneOtp";
import Button from "../../components/ui/Button";
import { MobileInput } from "../../components/ui/Form";
import { AuthContext } from "../../contexts/auth";
import { ToastContext } from "../../contexts/toast";
import { useUnauthenticatedApi } from "../../hooks/useApi";

interface ZoLoginProps {
  closeModal?: any;
  showModal?: boolean;
}

const ZoLogin: React.FC<ZoLoginProps> = () => {
  const [mobileNumber, setMobileNumber] = useState<string>();
  const { login } = useContext(AuthContext);
  const [otp, setOtp] = useState<string>("");
  const requestOTPApi = useUnauthenticatedApi("AUTH_REQUEST_OTP_MOBILE");
  const verifyOTPApi = useUnauthenticatedApi("AUTH_ACTIVATE");
  const [hasRequestedOTP, setRequestOTP] = useState<boolean>(false);
  const { addToast } = useContext(ToastContext);

  const handleRequestOTP = () => {
    if (mobileNumber) {
      const phoneNumber = parsePhoneNumber(`+${mobileNumber}`);
      const data = {
        mobile: phoneNumber.nationalNumber,
        mobile_country_code: phoneNumber.countryCallingCode,
      };
      requestOTPApi.post("/", data).then((response) => {
        if (response.data.success) {
          setRequestOTP(true);
        }
      });
    }
  };

  const handleButtonClick = () => {
    if (mobileNumber) {
      setRequestOTP(true);
      const phoneNumber = parsePhoneNumber(`+${mobileNumber}`);
      console.log(phoneNumber.countryCallingCode);
      handleRequestOTP();
    }
  };
  const handleEditNumber = () => {
    setRequestOTP(false);
  };

  const handleVerifyOTP = () => {
    if (mobileNumber) {
      const phoneNumber = parsePhoneNumber(`+${mobileNumber}`);
      const data = {
        mobile: phoneNumber.nationalNumber,
        mobile_country_code: phoneNumber.countryCallingCode,
        otp,
      };
      verifyOTPApi
        .post("/", data)
        .then((response) => {
          login(
            response.data.user_token,
            response.data.token_expiry,
            response.data.user
          );
        })
        .catch((error) => {
          addToast("Invalid Otp. Try again later.");
        });
    }
  };

  return (
    <div className="flex items-center justify-center mt-8 ">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        {!hasRequestedOTP ? (
          <>
            <div className="flex flex-col mt-4 space-y-4">
              <span className="text-text">Enter your mobile number below.</span>
              <MobileInput
                className="form-element-mobile"
                value={mobileNumber}
                setter={setMobileNumber}
              />
              <Button
                size="lg"
                onClick={handleButtonClick}
                disabled={
                  hasRequestedOTP || mobileNumber?.startsWith("91")
                    ? !isValidNumber("+" + mobileNumber, "IN")
                    : !isPossibleNumber("+" + mobileNumber)
                }
              >
                Request OTP
              </Button>
            </div>
          </>
        ) : (
          <div className="flex flex-col mt-4 space-y-4">
            <span className="text-text">
              OTP has been sent to{" "}
              <strong className="text-primary font-medium">
                +{mobileNumber}
              </strong>{" "}
              <button className="text-primary" onClick={handleEditNumber}>
                <i className="uil uil-edit" />
              </button>
              .
            </span>
            <div className="flex items-center justify-center">
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={<span>&nbsp;&nbsp;</span>}
                inputStyle={{
                  borderWidth: 1,
                  borderColor: "#e2e8f0",
                  borderRadius: 2,
                  height: 44,
                  width: 44,
                  outline: "none",
                }}
                renderInput={(props) => <input {...props} />}
              />
            </div>
            <Button
              size="lg"
              onClick={handleVerifyOTP}
              disabled={otp.length !== 6}
            >
              Zo Login
            </Button>
            <ResendOtp onPress={handleRequestOTP} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ZoLogin;
